import type { FC } from "react";
import { campaignsFormatNb } from "app/components/campaigns/shared/CampaignsUtils";
import { colorsPalettes } from "@similarweb/styles";
import { IconButton, Tooltip } from "@similarweb/ui-components"
import { Flex, Text } from "@similarweb/ui-components/foundations";
import { translate } from "app/filters/i18nFilter";
import { getMaxCampaigns } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/LLMTrackerUtils";

import { SWReactIcons } from "@similarweb/icons";
import { swSettings } from "app/common/services/swSettings";

interface IAccountBalanceBannerProps {
    campaignsCount: number;
    onHookClick: () => void;
}

export const AccountBalanceBanner: FC<IAccountBalanceBannerProps> = ({
    campaignsCount,
    onHookClick,
}) => {
    const isInternalUser = swSettings.user.isInternalUser;
    const maxCampaigns = getMaxCampaigns();

    return (
        <Flex
            gap="8px"
            alignItems="center"
            justifyContent="space-between"
            width="100%"
            height="40px"
            padding="2px 16px"
            borderRadius="4px"
            border={`1px solid ${colorsPalettes.bluegrey[400]}`}
        >
            <Flex gap="24px">
                <Flex gap="8px">
                    <Text
                        fontVariant={"subtitle2"}
                        color={colorsPalettes.carbon[400]}
                    >
                        {isInternalUser
                            ? translate("llm.homepage.account_balance.balance.internal")
                            : translate("llm.homepage.account_balance.balance.external")
                        }
                    </Text>
                    <Tooltip content={
                        isInternalUser
                            ? translate("llm.homepage.account_balance.balance.internal.tooltip")
                            : translate("llm.homepage.account_balance.balance.external.tooltip")
                    }>
                        <div>
                            <SWReactIcons
                                size="xs"
                                iconName="info"
                                iconColor={colorsPalettes.carbon[200]}
                            />
                        </div>
                    </Tooltip>
                </Flex>
                <Flex gap="8px">
                    <Text
                        fontVariant={"chip1"}
                        color={colorsPalettes.carbon[400]}
                    >
                        {translate("llm.homepage.account_balance.campaigns")}
                    </Text>
                    <Text
                        fontVariant="chip1TopRow"
                        color={colorsPalettes.carbon[400]}
                    >
                        {`${campaignsFormatNb(campaignsCount)}/${campaignsFormatNb(maxCampaigns)}`}
                    </Text>
                </Flex>
            </Flex>
            <IconButton
                type="flatTrial"
                iconSize="sm"
                iconName="spark"
                onClick={onHookClick}
            >
                {translate("llm.homepage.account_balance.hook")}
            </IconButton>
        </Flex>
    );
}